// extracted by mini-css-extract-plugin
export default {"integrationLinkOuter":"styles-module__hFu_F","link":"styles-module__wMMWR","linkIcon":"styles-module__d1rGI"};